import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import { useSelector, useDispatch } from "react-redux";


export default function ProductList() {
  const [allProduct, setAllProduct] = useState([]);
  const auth = useSelector(state => state.auth);

  const apiData = async () => {
    // const data ={email:auth?.user?.email,role:auth?.user?.role}
    const res = await axios.post("/getNewArrival");
    console.log(res?.status);
    console.log(res.data)
    if (res.status === 200) {
      setAllProduct(res?.data);
    } else {
      setAllProduct()
    }
  }

  useEffect(() => {
    apiData();
  }, [])

  const deleteProduct = async (descriptionId, stockId) => {
    const data = { descriptionId, stockId }
    const res = await axios.post("/deleteproductlist", data)
    if (res.status === 200) {
      apiData();
      alert("Product Deleted");
    }
  }

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              New Arrival List
              <small>it all starts here</small>
            </h1>

            <ol className="breadcrumb">
              <li>
                <a href="/#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li>
                <a href="/#">Product Manage</a>
              </li>
              <li className="active">All Product</li>
            </ol>
          </section>

          <section className="content">
            <div className="box box-section">
              <div className="box-body search-section">

                <div className=' col-sm-3'>
                  <button className="btn btn-danger">Export</button>
                </div>
              </div>
            </div>

            <div className="box">
              <div className="box-body">
                <table className="table table-bordered table-striped dataTable" >
                  <thead>
                    <tr>
                      <th className="fw-bold">{" "}<input type="checkbox" /></th>
                      <th>Product Name</th>
                      <th>Item Code</th>
                      <th>Sale Price</th>
                      <th>Regular Price</th>
                    </tr>
                  </thead>

                  <tbody>
                    {auth?.user?.role === "Admin" ? allProduct?.map((dt) => (
                      <tr>
                        <td><input type="checkbox" /></td>

                        <td>
                          <span className="text-uppercase fs-1">{dt?.name}</span>
                        </td>
                        <td>
                          {dt?.itemNo}
                        </td>
                        <td>{dt?.sale_price === null ? "0" : dt?.sale_price} {process.env.REACT_APP_CURRENCY}</td>
                        <td>{dt?.regular_price} {process.env.REACT_APP_CURRENCY}</td>
                      </tr>
                    )) : ""}
                  </tbody>
                  <tfooter>
                    <tr>
                      <td>Back</td>
                      <td>Next</td>
                    </tr>
                  </tfooter>
                </table>
              </div>
            </div>
          </section>
        </div>
        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  )
}

